module.exports = __webpack_public_path__ + "static/media/pen4.d5622651.png";